import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card.jsx";
import { Badge } from "@/components/ui/badge.jsx";
import { Button } from "@/components/ui/button.jsx";
import { Mail, Download, Clock, User, Building2 } from "lucide-react";
import { useState } from "react";

const mockEmailExchanges = [
  {
    id: "1",
    from: "mario@urban.fr",
    to: "charlotte@leano.fr",
    subject: "Demande de financement - Dossier Urban Solutions",
    date: "15/08/2024 14:30",
    content:
      "Bonjour Charlotte,\n\nJe me permets de vous contacter concernant notre demande de financement pour notre société Urban Solutions SARL. Nous avons besoin d'un crédit de 150 000€ pour développer notre activité.\n\nPouvez-vous me dire quels documents vous avez besoin pour étudier notre dossier ?\n\nCordialement,\nMario Rossi\nDirigeant - Urban Solutions SARL",
    type: "incoming",
  },
  {
    id: "2",
    from: "charlotte@leano.fr",
    to: "mario@urban.fr",
    subject: "RE: Demande de financement - Dossier Urban Solutions",
    date: "16/08/2024 09:15",
    content:
      "Bonjour Mario,\n\nMerci pour votre demande. Pour étudier votre dossier de financement, nous aurons besoin des documents suivants :\n\n• Dernière liasse fiscale complète (2023)\n• Relevés bancaires des 12 derniers mois\n• Kbis de moins de 3 mois\n• Business plan détaillé\n• Prévisionnels financiers sur 3 ans\n\nPouvez-vous nous transmettre ces éléments dans les meilleurs délais ?\n\nBien cordialement,\nCharlotte Dubois\nAnalyste Crédit - Leano",
    type: "outgoing",
    attachments: ["Liste_documents_requis.pdf"],
  },
  {
    id: "3",
    from: "mario@urban.fr",
    to: "charlotte@leano.fr",
    subject: "RE: Demande de financement - Documents transmis",
    date: "20/08/2024 16:45",
    content:
      "Bonjour Charlotte,\n\nVeuillez trouver en pièces jointes les documents demandés :\n\n- Liasse fiscale 2023\n- Relevés bancaires janvier-août 2024\n- Kbis récent\n- Business plan\n\nLe prévisionnel financier sera transmis demain matin.\n\nMerci pour votre suivi.\n\nCordialement,\nMario",
    type: "incoming",
    attachments: [
      "Liasse_fiscale_2023.pdf",
      "Releves_bancaires_2024.pdf",
      "Kbis_Urban_Solutions.pdf",
      "Business_plan_Urban.pdf",
    ],
  },
  {
    id: "4",
    from: "charlotte@leano.fr",
    to: "mario@urban.fr",
    subject: "RE: Analyse en cours - Questions complémentaires",
    date: "25/08/2024 11:20",
    content:
      "Bonjour Mario,\n\nNous avons bien reçu vos documents et notre équipe procède à l'analyse de votre dossier.\n\nNous avons quelques questions complémentaires :\n\n1. Pouvez-vous nous expliquer la baisse de CA observée en 2023 (-12%) ?\n2. Quelle est la nature exacte du poste \"Charges exceptionnelles\" (45 000€) ?\n3. Avez-vous des garanties à proposer pour ce financement ?\n\nDans l'attente de vos réponses.\n\nCordialement,\nCharlotte",
    type: "outgoing",
  },
  {
    id: "5",
    from: "mario@urban.fr",
    to: "charlotte@leano.fr",
    subject: "RE: Réponses aux questions complémentaires",
    date: "26/08/2024 14:10",
    content:
      "Bonjour Charlotte,\n\nVoici les réponses à vos questions :\n\n1. La baisse de CA en 2023 s'explique par la perte d'un gros client (30% du CA) suite à une réorganisation de leur part. Nous avons depuis diversifié notre portefeuille.\n\n2. Les charges exceptionnelles correspondent à des frais de déménagement et réaménagement de nos locaux.\n\n3. Nous pouvons proposer une hypothèque sur notre local commercial (valeur estimée 180 000€).\n\nJ'espère que ces éléments vous aideront dans votre analyse.\n\nCordialement,\nMario",
    type: "incoming",
  },
  {
    id: "6",
    from: "charlotte@leano.fr",
    to: "mario@urban.fr",
    subject: "Accord de principe - Conditions de financement",
    date: "02/09/2024 15:30",
    content:
      "Bonjour Mario,\n\nBonne nouvelle ! Nous vous confirmons notre accord de principe pour un financement de 150 000€.\n\nConditions proposées :\n• Montant : 150 000€\n• Durée : 7 ans\n• Taux : 4,2% (taux fixe)\n• Garantie : Hypothèque sur local commercial\n• Frais de dossier : 1 500€\n\nSi ces conditions vous conviennent, nous procéderons à la finalisation du dossier.\n\nRestant à votre disposition.\n\nCordialement,\nCharlotte Dubois",
    type: "outgoing",
    attachments: ["Offre_financement_Urban_Solutions.pdf"],
  },
];

export function EmailExchanges() {
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [showAllEmails, setShowAllEmails] = useState(false);

  const displayedEmails = showAllEmails
    ? mockEmailExchanges
    : mockEmailExchanges.slice(0, 3);

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 rounded-lg financial-gradient flex items-center justify-center">
          <Mail className="w-6 h-6 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-foreground">
            Échanges Emails
          </h1>
          <p className="text-muted-foreground">
            Historique complet des communications avec le prospect
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {/* Liste des emails */}
        <Card className="financial-card">
          <CardHeader>
            <CardTitle className="text-xl text-card-foreground flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <Mail className="w-5 h-5 text-primary" />
                <span>Conversation History</span>
              </div>
              <Badge variant="outline" className="text-xs">
                {mockEmailExchanges.length} messages
              </Badge>
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-3">
              {displayedEmails.map((email) => (
                <div
                  key={email.id}
                  className={`p-4 rounded-lg border cursor-pointer transition-all hover:shadow-md ${
                    selectedEmail?.id === email.id
                      ? "border-primary bg-primary/5"
                      : "border-border bg-card/50"
                  }`}
                  onClick={() => setSelectedEmail(email)}
                >
                  <div className="flex items-start justify-between mb-2">
                    <div className="flex items-center space-x-2">
                      {email.type === "outgoing" ? (
                        <Building2 className="w-4 h-4 text-primary" />
                      ) : (
                        <User className="w-4 h-4 text-muted-foreground" />
                      )}
                      <span className="font-medium text-sm text-card-foreground">
                        {email.type === "outgoing"
                          ? "Charlotte (Leano)"
                          : "Mario (Client)"}
                      </span>
                    </div>
                    <div className="flex items-center space-x-2 text-xs text-muted-foreground">
                      <Clock className="w-3 h-3" />
                      <span>{email.date}</span>
                    </div>
                  </div>

                  <h4 className="font-medium text-card-foreground text-sm mb-1 truncate">
                    {email.subject}
                  </h4>

                  <p className="text-xs text-muted-foreground line-clamp-2">
                    {email.content.split("\n")[0]}
                  </p>

                  {email.attachments && email.attachments.length > 0 && (
                    <div className="mt-2 flex items-center space-x-1">
                      <Download className="w-3 h-3 text-muted-foreground" />
                      <span className="text-xs text-muted-foreground">
                        {email.attachments.length} pièce(s) jointe(s)
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {!showAllEmails && mockEmailExchanges.length > 3 && (
              <Button
                variant="outline"
                onClick={() => setShowAllEmails(true)}
                className="w-full"
              >
                Voir tous les emails ({mockEmailExchanges.length - 3} de plus)
              </Button>
            )}
          </CardContent>
        </Card>

        {/* Détail de l'email sélectionné */}
        <Card className="financial-card">
          <CardHeader>
            <CardTitle className="text-xl text-card-foreground">
              {selectedEmail ? "Détail du message" : "Sélectionnez un email"}
            </CardTitle>
          </CardHeader>
          <CardContent>
            {selectedEmail ? (
              <div className="space-y-4">
                <div className="pb-4 border-b border-border/50">
                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div>
                      <span className="font-medium text-muted-foreground">
                        De :
                      </span>
                      <p className="text-card-foreground">
                        {selectedEmail.from}
                      </p>
                    </div>
                    <div>
                      <span className="font-medium text-muted-foreground">
                        À :
                      </span>
                      <p className="text-card-foreground">{selectedEmail.to}</p>
                    </div>
                    <div>
                      <span className="font-medium text-muted-foreground">
                        Date :
                      </span>
                      <p className="text-card-foreground">
                        {selectedEmail.date}
                      </p>
                    </div>
                    <div>
                      <span className="font-medium text-muted-foreground">
                        Type :
                      </span>
                      <Badge
                        variant={
                          selectedEmail.type === "outgoing"
                            ? "default"
                            : "secondary"
                        }
                      >
                        {selectedEmail.type === "outgoing" ? "Envoyé" : "Reçu"}
                      </Badge>
                    </div>
                  </div>
                </div>

                <div>
                  <h4 className="font-semibold text-card-foreground mb-2">
                    {selectedEmail.subject}
                  </h4>
                  <div className="bg-muted/30 p-4 rounded-md">
                    <pre className="whitespace-pre-wrap text-sm text-card-foreground font-normal">
                      {selectedEmail.content}
                    </pre>
                  </div>
                </div>

                {selectedEmail.attachments &&
                  selectedEmail.attachments.length > 0 && (
                    <div>
                      <h5 className="font-medium text-card-foreground mb-2">
                        Pièces jointes :
                      </h5>
                      <div className="space-y-2">
                        {selectedEmail.attachments.map((attachment, index) => (
                          <div
                            key={index}
                            className="flex items-center justify-between p-2 bg-muted/30 rounded-md"
                          >
                            <div className="flex items-center space-x-2">
                              <Download className="w-4 h-4 text-muted-foreground" />
                              <span className="text-sm text-card-foreground">
                                {attachment}
                              </span>
                            </div>
                            <Button size="sm" variant="outline">
                              Télécharger
                            </Button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
              </div>
            ) : (
              <div className="text-center py-8">
                <Mail className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
                <p className="text-muted-foreground">
                  Cliquez sur un email dans la liste pour voir son contenu
                  détaillé
                </p>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
